/* eslint-disable max-len */
import styled, { createGlobalStyle, css } from 'styled-components';
import { datepicker, datepickerDay, datepickerDayNames, datepickerHeader, datepickerMonth, datepickerMonthContainer, datepickerWeek, datepickerWrapper, dayOutsideMonth, dayWrapper, decemberMonth, inputContainer, lowAvailability, monthText, } from '@widgets/shared/components/CustomDatepicker/styles/defaults';
import { reworkCalendarDay, reworkCalendarDayOutside, reworkCalendarDays, reworkCalendarDOW, reworkCalendarHeader, reworkDefaults, reworkMonthContainer, } from '@widgets/shared/components/CustomDatepicker/styles/rework';
import { Wrapper as DayWrapper } from '@widgets/shared/components/CustomDatepicker/components/DatepickerDay/styles';
export const Wrapper = styled.div ``;
export const DatePickerStyles = createGlobalStyle `
  ${({ id, }) => css `
    #${id} {
      .react-datepicker-wrapper {
        ${datepickerWrapper};
      }
      
      .react-datepicker {
        ${datepicker};
        ${reworkDefaults}
        
        .react-datepicker__header {
          ${datepickerHeader};
          ${reworkCalendarHeader};
          
          .react-datepicker__day-names {
            ${datepickerDayNames};
            ${reworkCalendarDOW};
            
            .react-datepicker__day-name {
              ${datepickerDayNames};
              ${reworkCalendarDays};
            }
          }
        }
        
        .react-datepicker__month-container {
          ${datepickerMonthContainer}
          
          .react-datepicker__month {
            ${datepickerMonth}
            
            .react-datepicker__week {
              ${datepickerWeek}
              
              .react-datepicker__day {
                ${datepickerDay}
                ${reworkCalendarDay}
                
                ${DayWrapper} {
                  ${dayWrapper}
                }
                
                &--outside-month {
                  ${dayOutsideMonth}
                  ${reworkCalendarDayOutside}
                }
                
                &--disabled {
                  ${dayOutsideMonth}
                }
              }
            }

            .react-datepicker__month-text,
            .react-datepicker__quarter-text {
              ${monthText}
            }
          }
        }
        
        ${decemberMonth}

        &.has-low-availability .react-datepicker__month-container {
          ${lowAvailability}
        }
      }

      .react-datepicker__day-names,
      .react-datepicker__week {
        white-space: nowrap;
      }

      .react-datepicker__month-container {
        ${reworkMonthContainer}
      }

      .react-datepicker__input-container {
        ${inputContainer}
      }
    }
  `}}
`;
